<template>
  <div>
    <p style="    text-align: right;margin-top:20px;
    margin-right: 10px;font-weight: 600;" >Estado: {{estado}} </p>

    
      <p style="    text-align: right;
    margin-right: 10px;font-weight: 600;" >Somatoria dos valores de todas as notas: <span style="color: green;">{{qntNota}}</span></p>
  </div>
</template>

<script>

export default {
    props:['qntNota','estado']

}
</script>

<style>

</style>